import { SxProps, Theme } from '@mui/material';

export const stylesLandingPage: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'grey.100',
};

export const stylesBoxContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 1.5,
  height: '100%',
  p: 4,
  m: 4,
  backgroundColor: '#FFF',
};

export const stylesBoxChoice: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  mt: 4,
  gap: 4,
  flexWrap: 'wrap',
};
